import React from 'react'
import styled from '@emotion/styled'

import { Formik, ErrorMessage } from 'formik'
import * as yup from 'yup'

import Button from './Button'
import Heading from './Heading'

const Input = styled.input`
  margin-bottom: 38px;
  padding: 12px;
  border-radius: 4px;
  border: solid 1px ${props => props.theme.colours.lightGrey};
`

const SignInSchema = yup.object().shape({
  name: yup.string().required('Required'),
})

const SignInForm = ({ onSubmit }) => {
  return (
    <Formik
      initialValues={{ name: '' }}
      validationSchema={SignInSchema}
      validateOnBlur={false}
      onSubmit={onSubmit}
    >
      {props => (
        <form onSubmit={props.handleSubmit}>
          <Heading size={2}>
            <label htmlFor="name">What's your name?</label>
          </Heading>
          <br />
          <Input
            id="name"
            name="name"
            type="text"
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            value={props.values.name}
            placeholder="Mufasa"
          />
          <ErrorMessage name="name" />
          <br />
          <Button type="submit">Enter room</Button>
        </form>
      )}
    </Formik>
  )
}

export default SignInForm
